"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fuzzy_1 = require("fuzzy");
var react_1 = __importStar(require("react"));
var react_autosuggest_1 = __importDefault(require("react-autosuggest"));
var add_click_listener_for_attr_1 = __importDefault(require("../../utils/add-click-listener-for-attr"));
// configs
var minQueryLength = 1;
var maxSuggestionResultsLength = 10;
var minScore = 5;
exports.default = (function () {
    var _a = __read((0, react_1.useState)(false), 2), isOpen = _a[0], setIsOpen = _a[1];
    var _b = __read((0, react_1.useState)(''), 2), query = _b[0], setQuery = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), isLoading = _c[0], setIsLoading = _c[1];
    var _d = __read((0, react_1.useState)([]), 2), suggestions = _d[0], setSuggestions = _d[1];
    var _e = __read((0, react_1.useState)(), 2), allSuggestions = _e[0], setAllSuggestions = _e[1];
    (0, react_1.useEffect)(function () {
        (0, add_click_listener_for_attr_1.default)('data-search-app-trigger', function () { return setIsOpen(true); });
    }, []);
    if (!isOpen)
        return null;
    return (react_1.default.createElement("div", { className: 'position-relative bg-white padding-3', style: { boxShadow: 'rgba(0,0,0,0.3) 0px 8px 8px 0px' } },
        react_1.default.createElement("a", { href: 'javascript:;', className: 'position-absolute padding-2', onClick: function () { return setIsOpen(false); }, style: { top: '0.9rem', left: '0.6rem' } }, "X"),
        react_1.default.createElement(react_autosuggest_1.default, { suggestions: suggestions, onSuggestionsFetchRequested: function (_a) {
                var value = _a.value;
                if (!allSuggestions)
                    return;
                if (value.length >= minQueryLength) {
                    var results = (0, fuzzy_1.filter)(value, allSuggestions, { extract: function (s) { return s.fulltextCache; } });
                    setSuggestions(results
                        .filter(function (r) { return r.score >= minScore; })
                        .slice(0, maxSuggestionResultsLength)
                        .map(function (r) { return r.original; }));
                }
                else {
                    setSuggestions([]);
                }
            }, onSuggestionsClearRequested: function () {
                setQuery('');
                setSuggestions([]);
            }, getSuggestionValue: function (_a) {
                var title = _a.title;
                return title;
            }, onSuggestionSelected: function (e, _a) {
                var onlineStoreUrl = _a.suggestion.onlineStoreUrl;
                window.location.href = onlineStoreUrl;
            }, renderSuggestionsContainer: function (_a) {
                var containerProps = _a.containerProps, children = _a.children;
                return (react_1.default.createElement("div", __assign({}, containerProps),
                    query.length >= minQueryLength && (react_1.default.createElement("div", { className: 'margin-vertical-2' },
                        suggestions.length,
                        suggestions.length >= maxSuggestionResultsLength ? '+' : '',
                        " results")),
                    react_1.default.createElement("div", { className: 'overflow-y-scroll', style: { maxHeight: 380 } }, children)));
            }, renderSuggestion: function (_a) {
                var _b;
                var onlineStoreUrl = _a.onlineStoreUrl, images = _a.images, title = _a.title;
                return (react_1.default.createElement("a", { className: 'flex-container align-middle align-justify padding-horizontal-2 padding-vertical-1', href: onlineStoreUrl },
                    react_1.default.createElement("div", { className: 'flex-container align-middle' },
                        react_1.default.createElement("img", { src: (_b = images.edges[0]) === null || _b === void 0 ? void 0 : _b.node.transformedSrc, style: { width: 70 } }),
                        react_1.default.createElement("div", { className: 'padding-left-3 lh1' }, title))));
            }, inputProps: {
                autoFocus: true,
                className: 'border-none',
                value: query,
                onFocus: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!(!allSuggestions && !isLoading)) return [3 /*break*/, 2];
                                setIsLoading(true);
                                _a = setAllSuggestions;
                                return [4 /*yield*/, fetchAllSuggestions()];
                            case 1:
                                _a.apply(void 0, [_b.sent()]);
                                setIsLoading(false);
                                _b.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); },
                onChange: function (e, _a) {
                    var newValue = _a.newValue;
                    setQuery(newValue);
                },
            }, renderInputComponent: function (inputProps) { return (react_1.default.createElement("div", { className: 'margin-bottom-4 margin-left-8 margin-right-4' },
                react_1.default.createElement("input", __assign({}, inputProps, { placeholder: 'Search...' })))); }, theme: {
                suggestionsList: 'no-bullet',
            } })));
});
var fetchAllSuggestions = function () { return __awaiter(void 0, void 0, void 0, function () {
    var endpoint, res, body;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                endpoint = process.env.PERMANENT_DOMAIN ? "https://".concat(process.env.PERMANENT_DOMAIN) : '';
                return [4 /*yield*/, fetch(endpoint + '/api/2021-04/graphql', {
                        body: "\n      query {\n        collectionByHandle(handle: \"search-results\") {\n          products(first: 100) {\n            edges {\n              node {\n                collections(first: 20) {\n                  edges {\n                    node {\n                      title\n                    }\n                  }\n                }\n                onlineStoreUrl\n                title\n                description\n                images(first: 1, maxWidth: 40, maxHeight: 40) {\n                  edges {\n                    node {\n                      transformedSrc\n                    }\n                  }\n                }\n                seo {\n                  title\n                }\n                variants(first: 100) {\n                  edges {\n                    node {\n                      title\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }",
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/graphql',
                            'X-Shopify-Storefront-Access-Token': process.env.STOREFRONT_ACCESS_TOKEN || '',
                        },
                        method: 'POST',
                    })];
            case 1:
                res = _a.sent();
                return [4 /*yield*/, res.json()];
            case 2:
                body = (_a.sent());
                return [2 /*return*/, body.data.collectionByHandle.products.edges.map(function (e) { return (__assign(__assign({}, e.node), { 
                        // build the fulltextCache once so we can reuse many times while typing/searching
                        fulltextCache: [e.node.title, e.node.seo.title, e.node.variants.edges.map(function (ve) { return ve.node.title; }).join(' '), e.node.collections.edges.map(function (ce) { return ce.node.title; }).join(' ')].join(' ') })); })];
        }
    });
}); };
